// tslint:disable no-identical-functions
import { SearchFilters } from '../../search/schemas'

interface QueryPart {
  previousPoint?: string
}

export function toQuery({ previousPoint }: SearchFilters): QueryPart | {} {
  return {
    previousPoint: JSON.stringify(previousPoint) || undefined,
  }
}

export function fromQuery({ previousPoint }: QueryPart): {
  previousPoint?: string
} {
  return {
    previousPoint: previousPoint ? JSON.parse(previousPoint) : undefined,
  }
}
